export const SUB_STATUS = {
  trial: { label: "Essai", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  active: { label: "Actif", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  pending_payment: { label: "Paiement en attente", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  unpaid: { label: "Impayé", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  suspended: { label: "Suspendu", cls: "bg-rose-100 text-rose-800 border-rose-300" },
  cancelled: { label: "Résilié", cls: "bg-slate-800 text-white border-slate-800" },
  expired: { label: "Expiré", cls: "bg-slate-100 text-slate-600 border-slate-200" },
};

export const INVOICE_STATUS = {
  issued: { label: "Émise", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  partially_paid: { label: "Partiellement payée", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  paid: { label: "Payée", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  overdue: { label: "Impayée", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  void: { label: "Annulée", cls: "bg-slate-100 text-slate-500 border-slate-200" },
};

export const INTERVAL = { month: "Mensuel", quarter: "Trimestriel", year: "Annuel" };
export const METHOD = { bank_transfer: "Virement", cash: "Espèces", check: "Chèque", mobile_money: "Mobile money", card: "Carte bancaire", other: "Autre" };
export const LIMIT = { agencies: "Agences", members: "Collaborateurs", feedbacks_month: "Feedbacks / mois", options: "Options" };

export const money = (v, cur) => `${Number(v || 0).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${(cur || "").toUpperCase()}`;
export const limitText = (v) => (v === null || v === undefined ? "Illimité" : v);

export const Pill = ({ map, value, testId }) => (
  <span className={`inline-block whitespace-nowrap rounded-full border px-2 py-0.5 text-xs font-medium ${map[value]?.cls || ""}`} data-testid={testId}>{map[value]?.label || value}</span>
);
